export default __webpack_public_path__ + "static/media/edit-profie-data.44a67ea3.svg";